import "./_style.css"
import {useEffect, useState} from "react";

export default function StatItem (props: any) {

    const {editable, label, text, setObj} = props

    let labelsToKeys = {
        "Icecat Manager": "icecatManager",
        "Icecat PM": "icecatPM",
        "Icecat report emails": "reportEmails.icecat",
        "Client report emails": "reportEmails.client",
        "Feed data format": "dataFormat",
        "Feed access type": "accessType",
        "Feed access data": "accessCredentials",
        "Run mode": "runMode",
        "Notes": "feedNotes",
    }

    let valToPut = text

    let textareaRows = 0
    if (label === "Feed access data" || label === "Notes") {
        try {
            textareaRows = text.split('\n').length
        } catch (err) {}
    } else if (label === "Locales") {
        let sub = text.split(",")
        if (sub.length > 15) {
            let locsVal = ''
            let counter = 1
            for (let i of sub) {
                if (counter <= 15) {
                    locsVal += i.trim() + ', '
                    counter += 1
                } else {
                    locsVal += '\n'
                    counter = 1
                    textareaRows += 1
                }
            }
            valToPut = locsVal.substring(0, locsVal.length - 2)
            textareaRows += 1
        }
    }

    const [fieldStyle, setFieldStyle] = useState<any>(editable ? {border: "1px solid #e6e6e6", height: "auto"} : {border: "none", height: "auto"})

    const [isChanged, setIsChanged] = useState<boolean>(false)

    function handleChange(value: string, name: string) {
        let objKey = labelsToKeys[name as keyof typeof labelsToKeys]

        if (!objKey.includes(".")) {

            setObj((prevState: any) => {
                return {...prevState, [objKey as keyof typeof prevState]: value}
            })

            setFieldStyle((prevState: any) => {
                return {...prevState, backgroundColor: "#e6ffe6"}
            })
            setIsChanged(true)

        } else {
            let arr = objKey.split('.')

            let arrFromVal = value?.split(', ')
            setObj((prevState: any) => {
                return {...prevState,
                    [arr[0] as keyof typeof prevState]: {...prevState[arr[0]], [arr[1] as keyof typeof arr[0]]: arrFromVal}
                }
            })
        }
    }

    useEffect(() => {
        try {
            if (fieldStyle["backgroundColor"] === "#e6ffe6") {
                const timeId = setTimeout(() => {
                    // console.log("changing back to white")
                    setFieldStyle((prevState: any) => {
                        return {...prevState, backgroundColor: "white"}
                    })
                    setIsChanged(false)
                }, 3000)

                return () => {
                    clearTimeout(timeId)
                }
            }
        } catch (err) {
            console.log("Input field background changing", err)
        }
    }, [isChanged])

    return (
        <div className="statitem-container">
            <div className="statitem-label">{label}</div>

            {textareaRows > 0 ?
                <textarea
                    className="statitem-input"
                    // style={!editable ? {border: "none"} : {border: "1px solid #e6e6e6", height: "auto"}}
                    style={fieldStyle}
                    name={label}
                    rows={textareaRows}
                    onChange={(event) => handleChange(event.target.value, event.target.name)}
                    value={valToPut ? valToPut : ""}     // looks lame, otherwise Warning "A component is changing..."
                    disabled={!editable}
                    readOnly={!editable}
                />
                :
            <input
                className="statitem-input"
                // style={!editable ? {border: "none" } : {border: "1px solid #e6e6e6"}}
                style={fieldStyle}
                name={label}
                type="text"
                onChange={(event) => handleChange(event.target.value, event.target.name)}
                value={valToPut ? valToPut : ""}     // looks lame, otherwise Warning "A component is changing..."
                disabled={!editable}
                readOnly={!editable}
            />
            }
        </div>
    )
}
